module.exports = __webpack_public_path__ + "assets/img/kakao.42fa8962.png";